import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section footer-brand">
          <div className="footer-logo">
            <h2>OneMart</h2>
          </div>
          <p className="footer-description">
            Our support available to help you 24 hours a day, five days a week.
          </p>
        </div>

        <div className="footer-section">
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/home">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/products">Products</Link></li>
            <li><Link to="/contact">Contact Us</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h3>Contact Info</h3>
          <div className="contact-info">
            <p>APHB Colony Opp. Park, Near DLF Gate No. 3, Gachibowli, Hyderabad, 500032.</p>
          </div>
        </div>
      </div>

      <div className="footer-social">
        <div className="social-icons">
          <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <i className="social-icon">f</i>
          </a>
          <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
            <i className="social-icon">t</i>
          </a>
          <a href="https://youtube.com" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
            <i className="social-icon">y</i>
          </a>
          <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <i className="social-icon">in</i>
          </a>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; 2024 OneMart. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
